import { contactenResponseSchema } from '@ksyos/http';
import { initContract } from '@ts-rest/core';

const contract = initContract();

export const contactenContract = contract.router({
    getContacten: {
        metadata: {
            openApiTags: ['Patient'],
        },
        method: 'GET',
        path: `/api/v2/patient/contacten`,
        responses: {
            200: contactenResponseSchema,
        },
        summary: 'Get the contacten for a patient',
    },
});

export type ContactenContract = typeof contactenContract;
